import React, { useEffect } from 'react';

import MainLayout from '../../components/layout/Main';
import FeatureIntro from '../../components/organisms/featureIntro';
import usePageTitle from '../../hooks/usePageTitle';
import { MainLayoutHeader } from '../../components/atoms/mainLayoutHeader';
import { useTierGating } from '../../hooks/useTierGating';
import { useUpsellTracking } from '../../hooks/useUpsellTracking';
import FeatureIframe from '../../components/organisms/featureIframe';
import CompanyResearchImage from '../../assets/feature-intro-company-research.png';
import CompanyResearchTestimonialAvatar from '../../assets/feature-intro-company-research-testimonial-avatar.png';

export const CompanyResearch = () => {
  usePageTitle('Company Research');
  const { hasCapability } = useTierGating();
  const { trackPaywallShown } = useUpsellTracking();
  const hasAccess = hasCapability('company_research');

  useEffect(() => {
    if (!hasAccess) {
      trackPaywallShown('company_research');
    }
  }, [hasAccess, trackPaywallShown]);

  if (!hasAccess) {
    return (
      <MainLayout containerProps={{ pb: 0, minHeight: '100vh' }}>
        <MainLayoutHeader title="Company Research" />
        <FeatureIntro
          featureName="Company Research"
          title="Analyze companies with conviction"
          description="Discover the companies that perfectly match your specific search or thesis. Translate company research into business development, talent, or investment actions."
          features={[
            'Filter through millions of companies to find the right one',
            'Get 3rd party data signals overlaid with 1st party relationship signals',
            'Discover warm intro paths to employees at the companies in your search',
          ]}
          image={CompanyResearchImage}
          imageAlt="Company Research feature preview"
          ctaText="Get Company Research today"
          footerNote="Find the next investment, prospect, or insight"
          testimonial={{
            avatarSrc: CompanyResearchTestimonialAvatar,
            quote:
              'Precision search is a game changer for us. When we search… we get closer to our target list that much faster.',
            author: 'AI and Innovation Transformation Leader',
            role: 'Executive Search Firm',
          }}
        />
      </MainLayout>
    );
  }

  return <FeatureIframe featureKey="companyResearch" title="Findem Company Research" />;
};
